import { ReactNode } from 'react';

import { MetricsBox, Skeleton, Stack, tokens } from '@cast/design-system';

import { InventoryListItem } from '../../../_components/ui/InventoryListItem/InventoryListItem';

const MARKER_SIZE = 8;

const DashboardMetricMarkerSkeleton = () => (
  <Skeleton
    variant="rectangular"
    sx={{
      width: MARKER_SIZE,
      height: MARKER_SIZE,
      borderRadius: tokens.theme.radius.xs,
    }}
  />
);

const DashboardProgressBarSkeleton = ({ height = 8 }: { height?: number }) => (
  <Skeleton
    variant="rectangular"
    height={height}
    width="100%"
    sx={{ borderRadius: height / 2 }}
  />
);

const DashboardSingleMetricBoxSkeleton = ({ testId }: { testId: string }) => (
  <MetricsBox
    testId={testId}
    size="m"
    slots={{
      startContent: <DashboardMetricMarkerSkeleton />,
      label: <Skeleton variant="text" width={80} />,
      value: <Skeleton variant="text" width={40} />,
    }}
  />
);

const DashboardInventoryListSkeleton = ({
  count,
  dividerUntilIndex,
}: {
  count: number;
  dividerUntilIndex?: number;
}) => (
  <Stack gap={0}>
    {Array.from({ length: count }).map((_, index) => (
      <InventoryListItem
        key={index}
        size="sm"
        divider={index < (dividerUntilIndex ?? count - 1)}
        slots={{
          startContent: <DashboardMetricMarkerSkeleton />,
          label: <Skeleton variant="text" width={80} />,
          endContent: <Skeleton variant="text" width={24} />,
        }}
      />
    ))}
  </Stack>
);

export const DashboardMetricSummaryCardSkeleton = ({
  metricTestId,
  listCount,
  progressBarHeight,
  extraContent,
}: {
  metricTestId: string;
  listCount: number;
  progressBarHeight?: number;
  extraContent?: ReactNode;
}) => (
  <Stack height="100%" gap={24} justifyContent="space-between">
    <Stack gap={24} sx={{ flexShrink: 0 }}>
      <DashboardSingleMetricBoxSkeleton testId={metricTestId} />
      <DashboardProgressBarSkeleton height={progressBarHeight} />
      {extraContent}
    </Stack>
    <DashboardInventoryListSkeleton count={listCount} />
  </Stack>
);
